import React from "react";
import { SbEditableBlok, sbEditable } from "@storyblok/storyblok-editable";
import { useSelector } from "react-redux";
import { getStyleCss } from "../helper/css_style";
import { getIsDarkMode } from "../store/slices/webConfig";
import CustomStoryBlockComponent from "./CustomStoryBlockComponent";

interface ContainerProps {
  blok: SbEditableBlok;
  resourceData: Record<string, string>;
}

function Container({ blok, resourceData }: ContainerProps) {
  const isDarkMode = useSelector(getIsDarkMode);

  let styles: Record<string, string> = {
    maxWidth: "100vw"
  };

  let label = "";
  if (blok?.custom_style?.length > 0) {
    styles = getStyleCss(blok.custom_style, styles);
    if (styles.backgroundImage) {
      label = blok?.Name;
    }
  }

  if (isDarkMode) {
    if (styles.backgroundImage) {
      styles.filter = "grayscale(1)";
    } else if (styles.backgroundColor || styles.background) {
      styles.backgroundColor = "var(--color-bg-primary)";
      styles.background = "var(--color-bg-primary)";
    }
  }

  return (
    <div {...sbEditable(blok)} style={styles} className={`${blok.className}`} id={blok?.containerId} aria-label={label}>
      {blok.body.map((nestedBlok: SbEditableBlok) => (
        <CustomStoryBlockComponent key={nestedBlok._uid} resources={resourceData} blok={nestedBlok} />
      ))}
    </div>
  );
}

export default Container;
